import styled, { css } from 'styled-components';
import { rem } from '../../utils';
export const StyledWrapper = styled.label `
  display: flex;
  align-items: center;
  cursor: pointer;
  ${({ theme, size }) => css `
    width: ${rem(theme.Form.Switch.Size[size].width)};
    height: ${rem(theme.Form.Switch.Size[size].height)};
  `}
`;
export const StyledSwitch = styled.div `
  position: relative;

  ${({ theme, size }) => css `
    width: ${rem(theme.Form.Switch.Size[size].width)};
    height: ${rem(theme.Form.Switch.Size[size].height)};
    background: ${theme.Color.Neutrals.Border};
    border-radius: ${rem(theme.Form.Switch.Size[size].width)};
    padding: ${rem(theme.Form.Switch.Size[size].trackPadding)};
    transition: all ${theme.Transition.Timing.Out};
  `}

  &:before {
    content: '';
    position: absolute;
    border-radius: 50%;
    top: 50%;
    transform: translate(0, -50%);
    filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.16));

    ${({ theme, size }) => css `
      transition: all ${theme.Transition.Timing.In};
      width: ${rem(theme.Form.Switch.Size[size].handleSize)};
      height: ${rem(theme.Form.Switch.Size[size].handleSize)};
      left: ${rem(theme.Form.Switch.Size[size].trackPadding)};
      background: ${theme.Color.NeutralsFixed.Paper};
    `}
  }
`;
export const StyledInput = styled.input `
  opacity: 0;
  position: absolute;

  ${({ theme, inputSize }) => css `
    &:checked + ${StyledSwitch} {
      background: ${theme.Form.Switch.Color};

      &:before {
        transform: translate(
          ${rem(theme.Form.Switch.Size[inputSize].transitionDistance)},
          -50%
        );
      }
    }
  `}
`;
//# sourceMappingURL=Switch.style.js.map